/**
 * Zod-Schemas für Assignments (Disposition — Einsatz Worker × Client × Zeitraum).
 */
import { z } from 'zod';
import { ENTGELT_GROUPS, GERMAN_STATES } from '../enums/index.js';

const isoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Datum im Format YYYY-MM-DD')
  .optional()
  .or(z.literal(''));

/** Staff legt einen Einsatz an (workerId + clientId Pflicht). */
export const createAssignmentSchema = z.object({
  workerId: z.string().uuid(),
  clientId: z.string().uuid(),
  startDate: isoDate,
  endDate: isoDate,
  worksiteAddress: z.string().trim().max(300).optional(),
  /** Bundesland des Einsatzorts — Feiertags-Bestimmung (OPS-62/69). */
  worksiteState: z.enum(GERMAN_STATES).optional(),
  roleDescription: z.string().trim().max(300).optional(),
  /** Entgeltgruppe der Tätigkeit — Schlüssel in die Kunden-Preismatrix. */
  entgeltGroup: z.enum(ENTGELT_GROUPS).optional(),
  /** Manueller Verrechnungssatz-Override; ohne Angabe erbt der Einsatz aus der Matrix. */
  billRate: z.number().min(0).max(9999).optional(),
  notes: z.string().trim().max(2000).optional(),
});
export type CreateAssignmentInput = z.infer<typeof createAssignmentSchema>;

/** Staff pflegt die Einsatz-Stammdaten (ohne worker/client-Wechsel, ohne Status). */
export const updateAssignmentSchema = z.object({
  startDate: isoDate,
  endDate: isoDate,
  worksiteAddress: z.string().trim().max(300).optional(),
  roleDescription: z.string().trim().max(300).optional(),
  notes: z.string().trim().max(2000).optional(),
});
export type UpdateAssignmentInput = z.infer<typeof updateAssignmentSchema>;
